import { render, staticRenderFns } from "./ia-cliente-alocacao.vue?vue&type=template&id=6054f21c&scoped=true&"
import script from "./ia-cliente-alocacao.vue?vue&type=script&lang=js&"
export * from "./ia-cliente-alocacao.vue?vue&type=script&lang=js&"
import style0 from "./ia-cliente-alocacao.vue?vue&type=style&index=0&id=6054f21c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6054f21c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6054f21c')) {
      api.createRecord('6054f21c', component.options)
    } else {
      api.reload('6054f21c', component.options)
    }
    module.hot.accept("./ia-cliente-alocacao.vue?vue&type=template&id=6054f21c&scoped=true&", function () {
      api.rerender('6054f21c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/ia-cliente-painel/ia-cliente-alocacao.vue"
export default component.exports